import React, { useEffect, useState } from 'react';
import { observer, inject } from 'mobx-react';
import BoxTwoIcon from '../svg/BoxTwoIcon';
import MiniCartContent from './MiniCartContent';
import CartNotification from './CartNotification';
import { trackViewCart } from '@/utils/tracking';
import { syncCart } from '@/utils/cartSync';

const MiniCart = inject('wooCommerceStore', 'studioStore')(observer(({ wooCommerceStore, studioStore }) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  const productCount = isClient ? wooCommerceStore.cart.length : 0;

  const clearCart = () => {
    wooCommerceStore.clearCart();
    wooCommerceStore.toggleCart();
  };

  const handleToggleCart = async () => {
    wooCommerceStore.toggleCart();
    if (wooCommerceStore.isCartOpen) {
      // Cart is being opened now
      await syncCart({ preview: true });
      trackViewCart(wooCommerceStore.cart);
    }
  };

  return (
    <>
      <div className="mini-cart-container ms-2 my-2">
        <div data-testid="cart-icon" className="mini-cart-icon relative rounded-full p-3 lg:p-4 w-[4.4rem] lg:w-[6.87rem] h-[4.4rem] lg:h-[6.87rem]" onClick={handleToggleCart} style={{backgroundColor: studioStore?.settings?.colors?.primary_color}}>
          <BoxTwoIcon width="100%" height="100%" fill="#ffffff"/>
          <div data-testid="cart-count" className="cart-count absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gray-100 w-[1rem] h-[1rem] lg:w-[2rem] lg:h-[2rem] text-center font-semibold text-[0.825rem] lg:text-xl -mt-[0.31rem] leading-tight lg:leading-8 text-primary-studio">
            {productCount}
          </div>
        </div>
        <MiniCartContent toggleCart={handleToggleCart} clearCart={clearCart} productCount={productCount} cartItems={wooCommerceStore.cart} isOpen={wooCommerceStore.isCartOpen} />
      </div>
      <CartNotification />
    </>
  );
}));

export default MiniCart;
